import i18n from '../i18n.js';
export class DownloadBtn {
  constructor(container, onClick) { this.container = container; this.onClick = onClick; this.state = 'disabled'; this.render(); this.bindEvents(); }
  render() {
    this.container.innerHTML =
      '<button class="download-btn" id="download-btn" disabled>' +
      '<span class="spinner"></span>' +
      '<span class="btn-text">' + i18n.t('download.button') + '</span>' +
      '<span class="btn-loading-text">' + i18n.t('download.button.processing') + '</span></button>';
    this.btn = this.container.querySelector('#download-btn');
  }
  bindEvents() { var self = this; this.btn.addEventListener('click', function() { if (self.state === 'ready' && self.onClick) self.onClick(); }); }
  setState(state) { this.state = state; this.btn.disabled = (state === 'disabled' || state === 'processing'); this.btn.classList.toggle('processing', state === 'processing'); }
  setButtonText(text) { var bt = this.btn.querySelector('.btn-text'); if (bt) bt.textContent = text; }
  updateI18n() {
    var bt = this.btn.querySelector('.btn-text'); if (bt) bt.textContent = i18n.t('download.button');
    var lt = this.btn.querySelector('.btn-loading-text'); if (lt) lt.textContent = i18n.t('download.button.processing');
  }
}
